
export const data = [
    {
        img:"/Blockfarm/shop2.jpeg",
        title:"Iceriver KS3M 6TH",
        cat:"Iceriver",
        subImg1:"/Blockfarm/one11.jpeg",
        subImg2:"/Blockfarm/one1.jpg",
        subImg3:"/Blockfarm/one2.jpg",
        subImg4:"/Blockfarm/shop2.jpg",
        sub:"Bitmain Mining",
        Algorithm:"KHeavyHash",
        icon:"/Blockfarm/share.svg",
        amount:"$ 12.000,00",
        Megaheartz:"580J/TH",
        power:"3400W",
        btn:"Buy Now",
        delivery:"3-7 Days",
        date:'',
        mineable:"Kaspa",
        description:" Iceriver KS3M 6TH Is manufactured By Iceriver And it mines the KHeavyHash algorithm which has a maximum hashrate of 6Th/s with only 3400w power consumed."
    },
    {
        img:"/Blockfarm/shop8.jpeg",
        title:"Iceriver KSO Pro 200GH",
        cat:"Bitmain",
        subImg1:"/Blockfarm/iceriver2.jpg",
        subImg2:"/Blockfarm/iceriver3.jpg",
        subImg3:"/Blockfarm/iceriver4.jpg",
        subImg4:"/Blockfarm/iceriver5.jpg",
        Algorithm:"KHeavyHash",
        sub:"Bitmain Mining",
        icon:"/Blockfarm/share.svg",
        Megaheartz:"Megaheartz",
        power:"100W",
        amount:"$ 800,00",
        btn:"Buy Now",
        delivery:"3-7 Days",
        date:'',
        mineable:"Kaspa",
        description:"Iceriver KS0 Is manufactured By Iceriver And it mines the KHeavyHash algorithm which has a maximum hashrate of 200GH/s with only 100w power consumed."
    },
    {
        img:"/Blockfarm/shop6.png",
        title:"Antminer KS5 21T",
        cat:"Bitmain",
        subImg1:"/Blockfarm/Antm11.jpeg",
        subImg2:"/Blockfarm/Antm1.jpg",
        subImg3:"/Blockfarm/Antm2.jpg",
        subImg4:"/Blockfarm/iceriver5.jpg",
        Algorithm:"KHeavyHash",
        sub:"Bitmain",
        icon:"/Blockfarm/share.svg",
        Megaheartz:"Megaheartz",
        power:"3150W",
        amount:"$ 46.000,00",
        btn:"Buy Now",
        delivery:"3-7 Days",
        date:'March 2024',
        mineable:"Kaspa",
        description:"Antminer KS5 Is manufactured By Bitmain And it mines the KHeavyHash algorithm which has a maximum hashrate of 21Th/s with only 3150w power consumed."

    },
    {
        img:"/Blockfarm/shop4.png",
        title:"Antminer KS3 9.4TH",
        cat:"Bitmain",
        subImg1:"/Blockfarm/four1.png",
        subImg2:"/Blockfarm/four2.jpg",
        subImg3:"/Blockfarm/four3.jpg",
        subImg4:"/Blockfarm/iceriver5.jpg",
        Algorithm:"KHeavyHash",
        sub:"Bitmain",
        icon:"/Blockfarm/share.svg",
        Megaheartz:"Megaheartz",
        power:"3500W",
        amount:"$15.000,00",
        btn:"Buy Now",
        delivery:"3-7 Days",
        date:'Oct 2023',
        mineable:"Kaspa",
        description:"Antminer L7 Is manufactured By Bitmain And it mines the Scrypt algorithm which has a maximum hashrate of 9050MH/s with only 3425w power consumed."

    },
    {
        img:"/Blockfarm/Antminer.png",
        title:"Antminer L7 9050MH",
        cat:"Bitmain",
        subImg1:"/Blockfarm/five1.png",
        subImg2:"/Blockfarm/five2.jpg",
        subImg3:"/Blockfarm/five3.jpg",
        subImg4:"/Blockfarm/iceriver5.jpwg",
        Algorithm:"KHeavyHash",
        sub:"Bitmain Mining",
        icon:"/Blockfarm/share.svg",
        Megaheartz:"Megaheartz",
        power:"3425W",
        amount:"$ 6.400,00",
        btn:"Buy Now",
        delivery:"3-7 Days",
        date:'2023',
        mineable:"Dual Mining Dogecoin and Litecoin",
        description:"Antminer L7 Is manufactured By Bitmain And it mines the Scrypt algorithm which has a maximum hashrate of 9050MH/s with only 3425w power consumed."

    },
    {
        img:"/Blockfarm/shop3.png",
        title:"Antminer S21 200TH",
        cat:"Bitmain",
        subImg1:"/Blockfarm/five1.png",
        subImg2:"/Blockfarm/five2.jpg",
        subImg3:"/Blockfarm/five3.jpg",
        subImg4:"/Blockfarm/iceriver5.jpwg",
        Algorithm:"SHA-256",
        sub:"Bitmain",
        icon:"/Blockfarm/share.svg",
        Megaheartz:"Megaheartz",
        power:"3500W",
        amount:"$ 5.200,00",
        btn:"Buy Now",
        delivery:"3-7 Days",
        date:'Jan 2024',
        mineable:"Bitcoin",
        description:"Antminer S21 Is manufactured By Bitmain And it mines the SHA-256 algorithm which has a maximum hashrate of 200TH/s with only 3500w power consumed."

    },
    {
        img:"/Blockfarm/shop7.png",
        title:"Antminer S21 188TH",
        cat:"Bitmain",
        subImg1:"/Blockfarm/five1.png",
        subImg2:"/Blockfarm/five2.jpg",
        subImg3:"/Blockfarm/five3.jpg",
        subImg4:"/Blockfarm/iceriver5.jpwg",
        Algorithm:"SHA-256",
        sub:"Bitmain Mining",
        icon:"/Blockfarm/share.svg",
        Megaheartz:"Megaheartz",
        power:"3300W",
        amount:"$5.000,00",
        btn:"Buy Now",
        delivery:"3-7 Days",
        date:'Jan 2024',
        mineable:"Bitcoin",
        description:"Antminer S21 Is manufactured By Bitmain And it mines the SHA-256 algorithm which has a maximum hashrate of 188TH/s with only 3300w power consumed."

    },
    {
        img:"/Blockfarm/shop7.png",
        title:"Antminer S19 Xp 141TH",
        cat:"Bitmain",
        subImg1:"/Blockfarm/five1.png",
        subImg2:"/Blockfarm/five2.jpg",
        subImg3:"/Blockfarm/five3.jpg",
        subImg4:"/Blockfarm/iceriver5.jpwg",
        Algorithm:"SHA-256",
        sub:"Bitmain",
        icon:"/Blockfarm/share.svg",
        Megaheartz:"Megaheartz",
        power:"3050W",
        amount:"$ 3.400,00",
        btn:"Buy Now",
        delivery:"3-7 Days",
        date:'July 2023',
        mineable:"Bitcoin",
        description:"Antminer S19 XP Is manufactured By Bitmain And it mines the SHA-256 algorithm which has a maximum hashrate of 141TH/s with only 3050w power consumed."
    },
    {
        img:"/Blockfarm/shop7.png",
        title:"Antminer S19 Pro 120TH",
        cat:"",
        subImg1:"/Blockfarm/five1.png",
        subImg2:"/Blockfarm/five2.jpg",
        subImg3:"/Blockfarm/five3.jpg",
        subImg4:"/Blockfarm/iceriver5.jpwg",
        Algorithm:"SHA-256",
        sub:"Bitmain Mining",
        icon:"/Blockfarm/share.svg",
        Megaheartz:"Megaheartz",
        power:"2800W",
        amount:"$ 2.400,00",
        btn:"Buy Now",
        delivery:"3-7 Days",
        date:'April 2023',
        mineable:"Bitcoin",
        description:"Antminer S19K Pro Is manufactured By Bitmain And it mines the SHA-256 algorithm which has a maximum hashrate of 120TH/s with only 2800w power consumed."

    },
    {
        img:"/Blockfarm/shop7.png",
        title:"Antminer S19 Pro 115TH",
        cat:"SHA256/Bitcoin Miners",
        subImg1:"/Blockfarm/five1.png",
        subImg2:"/Blockfarm/five2.jpg",
        subImg3:"/Blockfarm/five3.jpg",
        subImg4:"/Blockfarm/iceriver5.jpwg",
        Algorithm:"SHA-256",
        sub:"Bitmain Mining",
        icon:"/Blockfarm/share.svg",
        Megaheartz:"Megaheartz",
        power:"2700W",
        amount:"$ 2.300,00",
        btn:"Buy Now",
        delivery:"3-7 Days",
        date:'April 2023',
        mineable:"Bitcoin",
        description:"Antminer S19K Pro Is manufactured By Bitmain And it mines the SHA-256 algorithm which has a maximum hashrate of 115TH/s with only 2700w power consumed."

    },
]



